import { createContext, useContext, useState } from 'react'
import { supabase } from '../supabase'

const AdminContext = createContext({})

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    const stored = localStorage.getItem('pc_admin')
    return stored ? JSON.parse(stored) : null
  })

  const signIn = async ({ email, password }) => {
    // Simple password check — in production use proper auth
    const ADMIN_PASSWORD = 'PCAdmin2026!'
    if (password !== ADMIN_PASSWORD) {
      return { error: 'Invalid credentials' }
    }

    const { data, error } = await supabase
      .from('admin_users')
      .select('*')
      .eq('email', email)
      .eq('is_active', true)
      .single()

    if (error || !data) return { error: 'Admin account not found' }

    await supabase
      .from('admin_users')
      .update({ last_login: new Date().toISOString() })
      .eq('id', data.id)

    localStorage.setItem('pc_admin', JSON.stringify(data))
    setAdmin(data)
    return { data }
  }

  const signOut = () => {
    localStorage.removeItem('pc_admin')
    setAdmin(null)
  }

  const hasAccess = (feature) => {
    if (!admin) return false
    const role = admin.role

    const permissions = {
      super_admin: ['all'],
      admin: ['sellers', 'help', 'verifications', 'stats', 'admins'],
      support: ['sellers_read', 'help', 'orders_read'],
      finance: ['finance', 'stats'],
      marketing: ['stats', 'sellers_read'],
      it: ['stats', 'sellers_read', 'tech'],
      account_manager: ['assigned_sellers'],
    }

    const userPerms = permissions[role] || []
    return userPerms.includes('all') || userPerms.includes(feature)
  }

  return (
    <AdminContext.Provider value={{ admin, signIn, signOut, hasAccess }}>
      {children}
    </AdminContext.Provider>
  )
}

export const useAdmin = () => useContext(AdminContext)